/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Door_Auto_TitleInputs */

const en_simple_door_auto_title = /** @type {(inputs: Simple_Door_Auto_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build it for me`)
};

const id_simple_door_auto_title = /** @type {(inputs: Simple_Door_Auto_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bangunkan untuk saya`)
};

/**
* | output |
* | --- |
* | "Build it for me" |
*
* @param {Simple_Door_Auto_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_door_auto_title = /** @type {((inputs?: Simple_Door_Auto_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Door_Auto_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_door_auto_title(inputs)
	return en_simple_door_auto_title(inputs)
});